import React from 'react';

export const DocumentNameIcon = () => (
  <svg height="13.884" viewBox="0 0 11.132 13.884" width="11.132" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M391.752,201.88h4.128m1.376,5.5h-6.88A1.376,1.376,0,0,1,389,206.008v-9.632A1.376,1.376,0,0,1,390.376,195h3.843a.687.687,0,0,1,.486.2l3.725,3.725a.687.687,0,0,1,.2.486v6.6A1.376,1.376,0,0,1,397.256,207.384Z"
      fill="none"
      stroke="#7f7f7f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(-388.25 -194.25)"
    />
  </svg>
);
